import { render, staticRenderFns } from "./PainelDesktop.vue?vue&type=template&id=37706150&scoped=true&"
import script from "./PainelDesktop.vue?vue&type=script&lang=js&"
export * from "./PainelDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PainelDesktop.vue?vue&type=style&index=0&id=37706150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37706150",
  null
  
)

export default component.exports